//#region src/scripts/extenders/localization-form.js
var LocalizationForm = class extends HTMLElement {
	constructor() {
		super();
		const formElement = this.querySelector("form");
		const allFieldsetElements = formElement.querySelectorAll("fieldset");
		const countryCodeInputElement = formElement.querySelector("input[name=\"country_code\"]");
		const languageCodeInputElement = formElement.querySelector("input[name=\"language_code\"]");
		allFieldsetElements.forEach((fielsetElement) => {
			fielsetElement.addEventListener("change", () => {
				const selectCountryElement = formElement.querySelector("select[name=\"country_code\"]");
				const radioCountryElement = formElement.querySelector("input[name=\"country_radio\"]:checked");
				const selectLanguageElement = formElement.querySelector("select[name=\"locale_code\"]");
				const radioLanguageElement = formElement.querySelector("input[name=\"language_radio\"]:checked");
				if (countryCodeInputElement) {
					if (selectCountryElement) countryCodeInputElement.value = selectCountryElement.options[selectCountryElement.selectedIndex].text;
					else if (radioCountryElement) countryCodeInputElement.value = radioCountryElement.value;
				}
				if (languageCodeInputElement) {
					if (selectLanguageElement) languageCodeInputElement.value = selectLanguageElement.options[selectLanguageElement.selectedIndex].text;
					else if (radioLanguageElement) languageCodeInputElement.value = radioLanguageElement.value;
				}
				if (formElement) formElement.submit();
			}, true, { passive: false });
		});
	}
};
if (customElements.get("localization-form") === void 0) customElements.define("localization-form", LocalizationForm);
//#endregion
